import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { Producto } from 'src/app/models/generic/Producto';
import { AutenticacionService } from 'src/app/services/autenticacion.service';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { MenuService } from '../../services/menu.service';
import { ProductosService } from '../../services/productos.service';
import { ProductosResumen } from '../../models/generic/ProductosResumen';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { AsesoresResumen } from 'src/app/models/generic/AsesoresResumen';
import { Listas } from 'src/app/models/generic/Listas';

@Component({
  selector: 'globalasesores',
  templateUrl: './globalasesores.component.html',
  styleUrls: ['./globalasesores.component.scss']
})
export class GlobalasesoresComponent implements OnInit{
  
  mostrarCargando: boolean = true;
  form: FormGroup;
  listaMeses: Listas[] = [];
  porcentajeMesAnterior: number = 0;

  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public autenticacionService: AutenticacionService,
    public menuService: MenuService,
    public productosService: ProductosService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.form = this.fb.group({
      mes: 0
    });

    if (this.autenticacionService.EstaAutenticado()) {
      this.cargarResumen();

      this.productosService.NotificarCambiarResumen.subscribe((cambiarResumen: boolean) => {
        if (cambiarResumen) {
          this.cargarResumen();
        }
      });
    }

    this.llenarComboMeses();
    this.form.get('mes').setValue(new Date().getMonth()+1);

    this.form.get('mes').valueChanges.subscribe((valorNuevo) => {
      this.cargarResumen(valorNuevo);
    });
  }

  llenarComboMeses() {
    this.listaMeses = [];
    this.listaMeses.push(this.crearItemMeses(1, 'Enero'));
    this.listaMeses.push(this.crearItemMeses(2, 'Febrero'));
    this.listaMeses.push(this.crearItemMeses(3, 'Marzo'));
    this.listaMeses.push(this.crearItemMeses(4, 'Abril'));
    this.listaMeses.push(this.crearItemMeses(5, 'Mayo'));
    this.listaMeses.push(this.crearItemMeses(6, 'Junio'));
    this.listaMeses.push(this.crearItemMeses(7, 'Julio'));
    this.listaMeses.push(this.crearItemMeses(8, 'Agosto'));
    this.listaMeses.push(this.crearItemMeses(9, 'Septiembre'));
    this.listaMeses.push(this.crearItemMeses(10, 'Octubre'));
    this.listaMeses.push(this.crearItemMeses(11, 'Noviembre'));
    this.listaMeses.push(this.crearItemMeses(12, 'Diciembre'));
  }

  crearItemMeses(mes: number, descripcion: string): Listas {
    let itemRetorno: Listas = new Listas();
    itemRetorno.id = mes;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }

  cargarResumen(mes: number = 0) {
    this.mostrarCargando = true;
    let parametrosConsulta = this.fb.group({
      mes: 0,
      idAplicacion: 0,
      canal: ''
    });

    parametrosConsulta.get('mes').setValue(mes);
    parametrosConsulta.get('idAplicacion').setValue(this.autenticacionService.AplicacionSeleccionadoInicial);
    parametrosConsulta.get('canal').setValue(this.autenticacionService.DescripcionCanalSeleccionadoInicial);
    
    this.productosService.CargarAsesoresResumen(parametrosConsulta.value).subscribe((resp: AsesoresResumen[]) => {
      this.productosService.ListaAsesoresResumen = resp;

      if (this.utilitariosService.VerificarContieneDatosLista(this.productosService.ListaAsesoresResumen)) {
        this.porcentajeMesAnterior = this.productosService.ListaAsesoresResumen[0].cantidadPorcentajeFrenteAlAnteriorTotal;
      }

      this.mostrarCargando = false;
    },
    (error: Error) => {
      this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
      this.mostrarCargando = false;
      this.cd.detectChanges();
    },
    () => this.cd.detectChanges());
  }
  ObtenerPorcentajeValor(item: AsesoresResumen): string {
    return `${item.cantidadPorcentaje}%`;
  }
  ColorPorcentajeMesAnterior(): string {
    if (this.porcentajeMesAnterior > 0) {
      return '#67CB9E';
    } else {
      return '#BF0D3E';
    }
  }
}
